import { endOfMonth, startOfMonth, subDays, subMonths } from 'date-fns'
import { Filters } from '../FiltersContext.types'
import { DateRange, FormFields } from '../partials/export-form'

export const getStartRange = (data: FormFields, filters: Filters) => {
  if (typeof filters.createdAtLocalStart === 'boolean' || Array.isArray(filters.createdAtLocalStart)) {
    return undefined
  }
  switch (data.dateRange) {
    case DateRange.Current: {
      return filters.createdAtLocalStart
    }
    case DateRange.Custom: {
      return data.from
    }
    case DateRange.Today: {
      return new Date()
    }
    case DateRange.CurrentMonth: {
      return startOfMonth(new Date())
    }
    case DateRange.Last7Days: {
      return subDays(new Date(), 7)
    }
    case DateRange.LastMonth: {
      return startOfMonth(subMonths(new Date(), 1))
    }
    default: {
      return undefined
    }
  }
}

export const getFinishRange = (data: FormFields, filters: Filters) => {
  if (typeof filters.createdAtLocalFinish === 'boolean' || Array.isArray(filters.createdAtLocalFinish)) {
    return undefined
  }
  switch (data.dateRange) {
    case DateRange.Current: {
      return filters.createdAtLocalFinish
    }
    case DateRange.Custom: {
      return data.to
    }
    case DateRange.Today: {
      return new Date()
    }
    case DateRange.CurrentMonth: {
      return endOfMonth(new Date())
    }
    case DateRange.Last7Days: {
      return new Date()
    }
    case DateRange.LastMonth: {
      return endOfMonth(subMonths(new Date(), 1))
    }
    default: {
      return undefined
    }
  }
}
